<section class="main-wrap inner-views dashboard-wrap new-sidebar" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap no-filters">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
        <!-- Eyelation will exclude filters and other additional features for launch  -LM -->
        <!--   <div class="filters-wrap">
        <ng-container >
          <app-shoe-filters [shoeFilterOptions]="shoesFilterOptions" (filterEvent)="filterData($event)" ></app-shoe-filters>
        </ng-container>
      </div> -->
    </div>
  </div>
  <div class="content-container products-container safety-shoes">
    <div class="row">
      <div class="col-md-12 dash-title">
        <h1>
          Shoe Accessories
        </h1>
      </div>
      <div class="clearfix"></div>
      @for (insole of shoeInsolesVM; track $index; let i = $index) {
        <div class="col-md-4">
          <div class="shop-tile">
            <div class="carousel slide carousel-fade" id="product_{{i}}">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <!-- <a [routerLink]="['/products/shoe-insoles', insole.style]"> -->
                  <img class="d-block w-100" [attr.src]="productImages + insole.insoleImage" loading="lazy"/>
                <!-- </a> -->
              </div>
            </div>
          </div>
          <button [attr.aria-controls]="'id-' + insole.id" class="btn product-detail" aria-expanded="false" [attr.data-target]="'#id-' + insole.id"
            data-toggle="collapse" type="button">
            Show Details
          </button>
          <div class="collapse" [attr.id]="'id-' + insole.id">
            <span class="insole-details" [innerHTML]="insole.description"></span>
          </div>
          <h3>{{insole.brand}}<span class="app-price">{{insole.price | currency}}</span></h3>
          <h6>{{insole.style}}</h6>
          <select class="form-control" id="shoe-insole" [(ngModel)]="insole.selectedOption">
            @for (model of insole.shoeInsoleModels; track $index) {
              <option [value]="model.sku">{{model.gender}}'s Size: {{model.sizeRange}}
              </option>
            }
          </select>
          <div class="text-center">
            <button class="btn product-btn gray-btn" type="button" (click)="addToCart(insole.selectedOption)">Add to Cart</button>
          </div>
        </div>
      </div>
    }
    <!--         <div class="clearfix"></div>
    <div *ngIf="totalItems" class="col-md-12 product-pagination">
      <app-product-pagination [currentPage]="currentPage" [pageSize]="30" [items]="totalItems" (pageChangeEvent)="pageChange($event)"></app-product-pagination>
    </div>
    <div class="clearfix"></div> -->
    <div class="col-md-12 text-right">
      <button [routerLink]="['/cart']" class="btn product-btn gray-btn" type="button">Checkout</button>
    </div>
  </div>
</div>
</div>
</section>
